<template>
  <div class="chartheight" ref="chart"></div>
</template>

<script>
export default {
  props: {
    ageNum: null,
  },
  data() {
    return {
      myCharts: null,
      chartData: [
        {
          value: this.ageNum[0].count,
          name: "男",
          itemStyle: { color: "#4878FF" },
        },
        {
          value: this.ageNum[1].count,
          name: "女",
          itemStyle: { color: "#36CBCB" },
        },
        {
          value: this.ageNum[2].count,
          name: "未识别",
          itemStyle: { color: "#F3F4F7", },
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
  },
  methods: {
    initChart() {
      this.myCharts = this.$echarts.init(this.$refs.chart);
      let arr = [];
      this.chartData.forEach((item, index) => {
        if (item.value != 0) {
           arr.push(item);
          // this.chartData.splice(index, 1);
        }
      });
      this.setOptions(arr);
    },
    setOptions(data) {
      let options = {
        // 提示框组件
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} 人 ({d}%)",
        },
        legend: {
          bottom:-5,
          icon: "circle",
          data: ["男", "女","未识别"],
          itemWidth: 8,
          itemHeight: 8,
          // itemStyle: { color: "#333" },
        },
        // 系列列表。每个系列通过 type 决定自己的图表类型
        series: {
          name: "性别",
          type: "pie",
          radius: ["50%", "65%"],
          avoidLabelOverlap: true,
          label: {
            show: true,
            formatter: '{b}: {@2012} ({d}%)',
            color:"#333"
            // position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "16",
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: true,
          },
          data: data,
        },
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      };
      this.myCharts.setOption(options);
    },
  },
};
</script>

<style scoped lang="scss">
.chartheight{
      height: 310px;
            @media screen and (max-width: 1400px){
              margin-top: 0px;
          height: 250px;
        }
          @media screen and (max-width: 1340px){
            margin-top: 0px;
          height: 180px;
        }
}
.order_money {
  height: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  overflow: hidden;
  .head {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 54px;
    padding: 0 24px;
    span {
      color: #2e3458;
      font-size: 16px;
      font-weight: 800;
    }
    img {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
    border-bottom: 1px solid #f6f6f6;
  }
  .content {
    height: 306px;
  }
}
</style>
